import { useMemo } from 'react'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import CruiseDescription from '../CruiseDescription'
import { isCruiseV1Offer } from 'lib/offer/offerTypes'
import { EmptyArray } from 'lib/array/arrayUtils'
import { getDistinctGrowthInclusions } from 'lib/offer/growthOfferTile'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import GrowthInclusionList from './GrowthInclusionList'

interface Props {
  offer: App.TourOffer | App.TourOfferSummary
}

/**
 * Growth highlight presentation for TourOfferCard.tsx, including legacy flash cruises.
 * Prefer curated tile inclusions, then package inclusions, and reuse OfferInclusionItem
 * for icons and copy. The new layout needs a three-row preview instead of the control
 * description; without inclusions, retain CruiseDescription or the offer's duration.
 */
function GrowthFlashTourInclusions({ offer }: Props) {
  const inclusions = offer.tileInclusions?.length ? offer.tileInclusions : offer.lowestPricePackage?.inclusions ?? EmptyArray
  const distinct = useMemo(() => getDistinctGrowthInclusions(inclusions), [inclusions])

  if (!distinct.length) {
    if (isCruiseV1Offer(offer)) return <CruiseDescription variant="condensed" offer={offer} />
    return offer.durationLabel ? <BodyTextBlock variant="small" lineClamp={1} startIcon={<LineCalendarIcon size="XS" />}>{offer.durationLabel}</BodyTextBlock> : null
  }

  return <GrowthInclusionList>
    {distinct.map(inclusion => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size="small" lineClamp={1} />)}
  </GrowthInclusionList>
}

export default GrowthFlashTourInclusions
